import { FormEvent, useState } from 'react';
import { SEOHead } from '../components/seo/SEOHead';
import { Input, Label, Textarea } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { ContactMap } from '../components/home/ContactMap';
import { api } from '../lib/api';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setStatus('submitting');
    try {
      await api.leads.create(form);
      setStatus('success');
      setForm({ name: '', email: '', phone: '', message: '' });
    } catch {
      setStatus('error');
    }
  }

  return (
    <>
      <SEOHead
        title="Contact Bharat Consultancy — Purulia Tax Consultant"
        description="Get in touch with Bharat Consultancy for GST, MSME, income tax, and registration services in Purulia, West Bengal."
        canonicalPath="/contact"
      />

      <section className="bg-paper py-12">
        <div className="mx-auto max-w-2xl px-4 sm:px-6">
          <h1 className="text-center font-display text-3xl font-bold text-ink">Get in Touch</h1>
          <p className="mt-2 text-center text-ink/65">
            Have a question or need help choosing a service? Send us a message.
          </p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-5 rounded-lg border border-line bg-white p-6">
            <div>
              <Label htmlFor="name">Full Name</Label>
              <Input
                id="name"
                required
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />
            </div>
            <div>
              <Label htmlFor="phone">Phone Number</Label>
              <Input
                id="phone"
                type="tel"
                required
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
              />
            </div>
            <div>
              <Label htmlFor="email">Email (optional)</Label>
              <Input
                id="email"
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>
            <div>
              <Label htmlFor="message">Message</Label>
              <Textarea
                id="message"
                rows={4}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
              />
            </div>

            <Button type="submit" className="w-full" disabled={status === 'submitting'}>
              {status === 'submitting' ? 'Sending...' : 'Send Message'}
            </Button>

            {status === 'success' && (
              <p className="text-center text-sm text-ledger-green">
                Thanks! We've received your message and will get back to you soon.
              </p>
            )}
            {status === 'error' && (
              <p className="text-center text-sm text-red-600">Something went wrong. Please call us directly.</p>
            )}
          </form>
        </div>
      </section>

      <ContactMap />
    </>
  );
}
